/**
 * 商品比較
 *
 */

{


  const compareToggleButtons = document.querySelectorAll('.sbn-js-selecting');
  let compareList = [];
  const currentCompareList = localStorage.getItem('compareList') || '[]';
  if (currentCompareList) {
    compareList = JSON.parse(currentCompareList);
  }


  // 比較ボタンの挙動
  // -----------------------------------------------------------
  const initCompareToggleButton = () => {
    checkInCompareList();

    compareToggleButtons.forEach(button => {
      // クリックした時の挙動（LocalStorageに保存、削除）
      button.addEventListener('click', function() {
        if(this.classList.contains('is-selected')) {
          // 削除
          const productDataText = this.querySelector('script[type="application/json"]').innerText;
          const productData = JSON.parse(productDataText);
          compareList = compareList.length > 0 ? compareList.filter((item) => item.product_id !== productData.product_id) : [];
          this.classList.remove('is-selected');
        } else {
          // 保存
          const productDataText = this.querySelector('script[type="application/json"]').innerText;
          const productData = JSON.parse(productDataText);

          console.log({productData});
          compareList.push(productData);
          this.classList.add('is-selected');
        }
        saveCompareList();
      });
    });
  }


  // 比較リストにあるかどうかのチェック
  // -----------------------------------------------------------
  const checkInCompareList = ()=>{
    console.log('compareList',compareList);
    compareList.forEach(item => {
      const buttons = document.querySelectorAll(`[data-variant-id="${item.product_id}"]`);
      buttons.forEach(button => {
        const parent = button.closest('.sbn-c-button-compare');
        if (parent) {
          parent.classList.add('sbn-is-active', 'is-selected');
        }

        const card = button.closest('.sbn-js-selecting');
        if (card) {
          card.classList.add('sbn-is-active', 'is-selected');
        }
      });
    })
  }

  // LocalStorageに保存
  // -----------------------------------------------------------
  const saveCompareList = () => {
    // compareListで重複しているものは削除
    // 同じproduct_idがあれば削除
    const uniqueCompareList = compareList.length > 0 ? compareList.filter((item, index, self) =>
      index === self.findIndex((t) => t.product_id === item.product_id)
    ) : [];
    localStorage.setItem('compareList', JSON.stringify(uniqueCompareList));
    displaySelectedItemImage();
    checkInCompareList();
  }

  // LocalStorageから取得
  // -----------------------------------------------------------
  const getCompareList = () => {
    return JSON.parse(localStorage.getItem('compareList'));
  }



  // アイテム比較 BOXに選択中の商品画像を表示
  // -----------------------------------------------------------
  const displaySelectedItemImage = () => {
    const selectedItemBox = document.querySelectorAll('.sbn-c-comparisonBox');

    if(!selectedItemBox) return;
    console.log('============ displaySelectedItemImage ============');
    selectedItemBox.forEach(box => {
      const selectedItemBoxInner = box.querySelector('.sbn-c-comparisonBox__list');
      if(!selectedItemBoxInner) {
        console.error('selectedItemBoxInner not found');
        return;
      }

      selectedItemBoxInner.innerHTML = '';


      compareList.forEach(item => {
        console.log({item});
        if(item.color_image) {
          const image = document.createElement('img');
          image.src = item.color_image;
          selectedItemBoxInner.appendChild(image);
        }
      });

      console.log('After appending images:', selectedItemBoxInner.innerHTML);
    })
  }

  // 商品情報をAjaxで取得
  // -----------------------------------------------------------
  const fetchProductData = async (handle) => {
    try {
      console.log('Fetching product data for handle:', handle);
      const response = await fetch(`/products/${handle}`);
      if (!response.ok) {
        throw new Error('商品情報の取得に失敗しました');
      }
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const jsonScript = doc.querySelector('script[type="application/json"][data-variant-id]');
      if (!jsonScript) {
        throw new Error('JSONデータが見つかりません');
      }
      const data = JSON.parse(jsonScript.textContent);
      console.log('Fetched product data:', data);
      return data;
    } catch (error) {
      console.error('商品情報の取得エラー:', error);
      return null;
    }
  }

  // 比較ページで描画
  // -----------------------------------------------------------
  const initComparisonPage = async () => {
    console.log('============ initComparisonPage ============');
    console.log('Current compareList:', compareList);
    const comparisonSlider = document.querySelector('.comparison-container-slider');
    if(!comparisonSlider) return;
    const comparisonSliderInner = comparisonSlider.querySelector('.swiper-wrapper');
    comparisonSliderInner.innerHTML = '';

    if(compareList.length === 0 ) {
      document.querySelector('.comparison-container').classList.add('is-empty');
      document.querySelector('.comparison-container').innerHTML = `
      <div class="comparison-container__empty">
        <p>比較する商品がありません。</p>
      </div>
      `;
      return;
    }

    // 商品情報を取得して描画
    const productPromises = compareList.map(async (item) => {
      console.log('Processing item:', item);
      const productData = await fetchProductData(item.handle);
      console.log('productData',productData);
      if (!productData) return null;
      console.log('Product data for rendering:', productData);

      const comparisonItem = document.createElement('div');
      comparisonItem.classList.add('comparison-container__item');
      comparisonItem.classList.add('comparisonColumn');
      comparisonItem.classList.add('swiper-slide');
      comparisonItem.setAttribute('data-product-id', productData.product_id);

      // 価格の処理を修正
      let price_html = '';
      if (typeof productData.price === 'string') {
        price_html = productData.price.replace(/通常価格/, '希望小売価格').replace('sbn-u-font-notosans', '');
      } else if (typeof productData.price === 'number') {
        price_html = `¥${productData.price.toLocaleString()}`;
      }

      const is_sale = typeof productData.price === 'string' &&
        productData.price.includes('sbn-c-label-sale') ? 'is-sale' : 'is-normal';

      comparisonItem.innerHTML = `
      <div class="comparisonColumn__item item-image">
          <button class="sbn-c-button-compare sbn-u-hover-trans comparisonColumn__delete">
              <div class="sbn-c-button-compare__wrapper"><span class="sbn-c-button-compare__label sbn-c-button-compare__label--off">比較を解除</span></div><span class="sbn-c-icon-accordion"></span>
          </button>
          <div class="comparisonColumn__item-image">
              <img src="${productData.feature_image}" alt="${productData.title}">
          </div>
          <div class="comparisonColumn__item-name">
              ${productData.title}
          </div>
      </div>
      <div class="comparisonColumn__item item-color">
          ${productData.color}
      </div>
      <div class="comparisonColumn__item item-price ${is_sale}">
        ${price_html.replace(/¥/g, '')}
      </div>
      <div class="comparisonColumn__item item-number">
          ${productData.sku}
      </div>
      <div class="comparisonColumn__item item-size">
          ${productData.size}
      </div>
      <div class="comparisonColumn__item item-size">
          ${productData.outer_size}
      </div>
      <div class="comparisonColumn__item item-weight">
          ${productData.weight}
      </div>
      <div class="comparisonColumn__item item-material">
          ${productData.material_1_main}
      </div>
      <div class="comparisonColumn__item item-back">
          ${productData.back}
      </div>
      <div class="comparisonColumn__item item-shoulder">
          ${productData.shoulder_belt}
      </div>
      <div class="comparisonColumn__item item-shape">
          ${productData.shape}
      </div>
      <div class="comparisonColumn__item item-lock">
          ${productData.lock_type}
      </div>
      <div class="comparisonColumn__item item-time">
          ${productData.timetable}
      </div>
      <div class="comparisonColumn__item item-accessory">
          ${productData.other_features}
      </div>
      <div class="comparisonColumn__item item-special">
          ${productData.speacial_features}
      </div>
      <div class="comparisonColumn__item item-plus">
          ${productData.plus_features}
      </div>
      <div class="comparisonColumn__item item-button">
          <a href="/products/${productData.handle}" class="sbn-c-button-more sbn-u-hover-zoomin--background">商品詳細を見る</a>
      </div>
      `;
      return comparisonItem;
    });

    const comparisonItems = await Promise.all(productPromises);
    comparisonItems.forEach(item => {
      if (item) {
        comparisonSliderInner.appendChild(item);
      }
    });

    // 画像の読み込みが完了した後に高さを調整し、スライダーを初期化
    const adjustHeightsAndInitSlider = async () => {
      const comparisonItemImages = document.querySelectorAll('.comparisonColumn__item-image img');
      const imageLoadPromises = Array.from(comparisonItemImages).map(image => {
        return new Promise(resolve => {
          if (image.complete) {
            resolve();
          } else {
            image.addEventListener('load', resolve);
          }
        });
      });

      await Promise.all(imageLoadPromises);

      // 各項目の高さを合わせる
      const comparisonItems = [
        'item-image',
        'item-color',
        // 'item-feature',
        'item-price',
        'item-number',
        'item-size',
        'item-weight',
        'item-material',
        'item-back',
        'item-shoulder',
        'item-shape',
        'item-lock',
        'item-time',
        'item-accessory',
        'item-special',
        'item-plus',
        'item-button',
      ];

      comparisonItems.forEach(item => {
        let maxHeight = 0;
        const comparisonItem = document.querySelectorAll(`.${item}`);
        comparisonItem.forEach(item => {
          if (item.offsetHeight > maxHeight) {
            maxHeight = item.offsetHeight;
          }
        });
        document.documentElement.style.setProperty(`--height-${item}`, `${maxHeight}px`);
      });

      // スライダーの初期化
      const comparisonSliderInit = new Swiper('.comparison-container-slider', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: false,
        scrollbar: {
          el: '.comparison-container-scrollbar',
          draggable: true,
        },
      });

      // 画面幅が変更された時に表の高さを再調整
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          adjustHeightsAndInitSlider();
        }, 250); // 250msのディレイを設定
      });
    };

    adjustHeightsAndInitSlider();

    // 削除ボタンの有効化
    const deleteButtons = document.querySelectorAll('.comparisonColumn__delete');
    deleteButtons.forEach(button => {
      button.addEventListener('click', () => {
        const productId = button.closest('.comparisonColumn').getAttribute('data-product-id');
        console.log('productId',productId);
        console.log("button.closest('.comparisonColumn')",button.closest('.comparisonColumn'));
        compareList = compareList.filter(item => item.product_id !== productId);
        console.log('compareList',compareList);
        saveCompareList();
        initComparisonPage();
      })
    })


  }


// アイテム全部消去
const deleteAllList = () =>{
  const deleteButton = document.querySelectorAll('.sbn-c-comparisonBox__delete-btn');
  if(!deleteButton) return;

  deleteButton.forEach(button => {
    button.addEventListener('click', (event) => {
      console.log('============ deleteAllList ============');
      if (event.target.tagName === 'SPAN' || event.target === deleteButton) {
        compareList = [];
        saveCompareList();
        initComparisonPage();
        compareToggleButtons.forEach(button => {
        button.classList.remove('is-selected');
        button.classList.remove('sbn-is-active');
      })
      document.querySelectorAll('.sbn-c-button-compare.is-selected').forEach(button => {
        button.classList.remove('sbn-is-active');
          button.classList.remove('is-selected');
        })
      }
    })
  })

}

  document.addEventListener('DOMContentLoaded', () => {
    console.log('============ init compareToggleButton ============');
    initCompareToggleButton();
    initComparisonPage();
    deleteAllList();
    displaySelectedItemImage();

  });

}
